import { Directive, effect, input, signal } from '@angular/core'

import { theme } from '@flowx/core-sdk'
import { MarkdownStyles, applyMarkdownCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-markdown',
  exportAs: 'flxMarkdownStyle',
  standalone: true,
})
export class FlxMarkdownStyleDirective {
  componentStyle = input.required<{
    style: MarkdownStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyMarkdownCustomStyles(this.componentStyle().style, theme())
      this.styleClassName.set(className)
    })
  }
}
